import React from 'react'
import "./BaseHtmlRendering.css"

interface BaseHtmlRenderingProps {
  html?: string | null
  className?: string
}

export const BaseHtmlRendering = ({
  html,
  className,
}: BaseHtmlRenderingProps) => {
  if (!html) {
    return null
  }
  const createMarkup = (content: string) => ({ __html: content })

  return (
    <div
      id="html-rendering"
      dangerouslySetInnerHTML={createMarkup(html.replace(/\n/g, '<br />'))}
      className={className}
    />
  )
}
